// extracted by mini-css-extract-plugin
export default {"dataManagementNavbar":"dataManagement_dataManagementNavbar__Rtcqz"};